module.exports = __webpack_public_path__ + "static/media/Walrein_gaussian2.f6e45f7d.png";